export function getCSSVariableValue(variableName: string) {
  const value = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();
  return value;
}
